import React, { useState } from "react";
import DeleteIcon from "@atlaskit/icon/core/delete";
import Button from "@atlaskit/button/new";
import Tooltip from "@atlaskit/tooltip";
import ConfirmModal from "../../../../../common/components/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setEditorSaved, saveFlow } from "../../../../../redux/actions/integrationActions";

const DeleteActionMenuItem = ({ action, showParentModal, iconOnly = false }) => {
  const flow = useSelector((state) => state.integration.flow);
  const [isShowConfirmModal, setShowConfirmModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOnDeleteClick = () => {
    setShowConfirmModal(true);
    if (typeof showParentModal === "function") {
      showParentModal(false);
    }
  };

  const doDeleteAction = () => {
    setShowConfirmModal(false);
    removeActionById(action.id);
    dispatch(setEditorSaved(true));
    dispatch(saveFlow(flow));
    navigate("/integration/" + flow.id + "/details");
  };

  const removeActionById = (id) => {
    const remainingActions = flow.actions ? flow.actions.filter((a) => a.id !== id) : [];
    flow.actions = remainingActions;
    findChildrenForActionId(id).forEach((a) => {
      removeActionById(a.id);
    });
  };

  const findChildrenForActionId = (id) => {
    return flow.actions ? flow.actions.filter((a) => a.parentId === id) : [];
  };

  const findDescendantsForActionId = (id) => {
    const descendants = [];
    const stack = findChildrenForActionId(id);

    while (stack.length > 0) {
      const child = stack.shift();
      descendants.push(child);
      stack.push(...findChildrenForActionId(child.id));
    }

    return descendants;
  };

  const childActionCount = action?.id ? findDescendantsForActionId(action.id).length : 0;
  const childActionLabel = childActionCount === 1 ? "child action" : "child actions";
  const deleteActionLabel =
    childActionCount > 0 ? `delete action (and all ${childActionCount} ${childActionLabel})` : "delete action";

  if (iconOnly) {
    return (
      <>
        <Tooltip position="top" content="Delete action">
          <Button iconBefore={DeleteIcon} appearance="subtle" onClick={handleOnDeleteClick} aria-label="Delete action" />
        </Tooltip>
        <ConfirmModal
          action={deleteActionLabel}
          targetName={action ? action.name : ""}
          targetId={action ? action.id : ""}
          isOpen={isShowConfirmModal}
          onAction={doDeleteAction}
          onClose={() => setShowConfirmModal(false)}
        />
      </>
    );
  }

  return (
    <>
      <Button iconBefore={DeleteIcon} appearance="subtle" onClick={handleOnDeleteClick}>
        Delete action
      </Button>
      <ConfirmModal
        action={deleteActionLabel}
        targetName={action ? action.name : ""}
        targetId={action ? action.id : ""}
        isOpen={isShowConfirmModal}
        onAction={doDeleteAction}
        onClose={() => setShowConfirmModal(false)}
      />
    </>
  );
};
export default DeleteActionMenuItem;
